/**
 * 雨量計測地点テーブル
 */
export default class uryoPointNameTable {
    _table = {};
    /**
     * コンストラクタ
     */
    constructor() {
        // 雨量地点属性ファイル取得
        let uryoConfig = getCsv(config.uryoConfigUrl);
        let ct = csvDef.telpsn;
        //  ファイル読込
        for (let j = 0; j < uryoConfig.length; j++) {
            let ccd = uryoConfig[j][ct.colCcd];
            let scd = uryoConfig[j][ct.colShinkokyoku];
            this._table[ccd] = {
                ccd: ccd,
                ccdName: uryoConfig[j][ct.colChitenName],
                ccdNameKana: "",
                ccdAddress: "",
                scd: scd,
            };
        }
    }
    /**
     * 雨量計測地点情報の取得
     * @param ccd
     */
    getInfo(ccd) {
        if (ccd) {
            let rec = this._table[ccd];
            if (!rec.ccdAddress) {
                let path = config.uryouUrl(rec.scd);
                let uryoCsv = getCsv(path);
                let cu = csvDef.uryou;
                for (let i = 1; i < uryoCsv.length; i++) {
                    if (uryoCsv[i][cu.colCcd] == ccd) {
                        rec.ccdName = uryoCsv[i][cu.colChitenName];
                        rec.ccdNameKana = uryoCsv[i][cu.colChitenNameHiranaga];
                        rec.ccdAddress = uryoCsv[i][cu.colAddress];
                        break;
                    }
                }
            }
            return rec;
        }
        else {
            return {
                ccd: "",
                ccdName: "",
                ccdNameKana: "",
                ccdAddress: "",
                scd: "",
            };
        }
    }
}
